module.exports = __webpack_public_path__ + "img/963-b661da.png";